define('SageDotCom/DataLayer/Events/searchInteraction',["jquery", "SageDotCom/DataLayer/Events/eventBase"], function ($, EventBase) {

    function SearchInteractionEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = "search_int"; // overwrite name
    }

    SearchInteractionEvent.prototype = Object.create(EventBase.prototype);

    SearchInteractionEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope, term, resultPage) {
        var eventData = {
            'event_name': this.getName(),
            'event_non-int': "0",
            'event_category': "search",
            'event_action': "search"
        }

        if (scope) {
            var label = $("input[type='submit'], button[type='submit']", scope).text();

            var location = this.getLocation(scope);

            eventData = $.extend(eventData, {
                'event_label': this.stripHtml(label.trim()), // strip any html
                'event_name_level_1': this.getId(scope),
                'event_name_level_2': resultPage,
                'event_name_level_3': term,
                'event_name_level_4': location
            });
        }

        return eventData;
    }

    return new SearchInteractionEvent();
});
